import * as z from "zod";
import { mutator } from "./mutator";
import { viewNavSource } from "./viewAnalytics";

const SPACE_TABS = [
  "workflows",
  "links",
  "leaderboard",
  "settings",
  "access",
] as const;

const spaceTab = z.enum(SPACE_TABS);

export type SpaceTab = z.infer<typeof spaceTab>;

const markSpaceTabViewedSchema = z.object({
  spaceId: z.string().max(64),
  tab: spaceTab,
  visitId: z.string().max(64),
  navSource: viewNavSource,
  priorTab: spaceTab.nullish(),
});

export const markSpaceTabViewed = mutator({
  schema: markSpaceTabViewedSchema,
  resolve: {},
  permissions: { none: "records that the caller looked at their own screen" },
  description:
    "Triggered when a user opens a tab on a space’s page or settings.",
  interactionType: "view",
  fn: async () => {},
});
